(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'uncommon:rfq:draft:v2';
    const VERSION = 2;
    const TTL = 30 * 24 * 60 * 60 * 1000;
    const t = (key, fallback) => {
      try {
        if (window.Shopify && window.Shopify.locale && typeof window.theme?.strings === 'object') {
          /* intentionally unused — fallback path */
        }
      } catch (_) { /* ignore */ }
      return fallback || key;
    };

    const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>'"]/g, (char) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    }[char]));

    const rootRoute = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const absoluteUrl = (url) => {
      try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.delete('oseid');
        parsed.searchParams.delete('preview_theme_id');
        return parsed.href;
      } catch (_) { return url || ''; }
    };

    const parseDraft = () => {
      try {
        const value = JSON.parse(localStorage.getItem(STORAGE_KEY));
        if (!value || value.version !== VERSION || value.expiresAt <= Date.now()) {
          localStorage.removeItem(STORAGE_KEY);
          return null;
        }
        return value;
      } catch (error) {
        return null;
      }
    };

    const clearDraft = () => {
      try { localStorage.removeItem(STORAGE_KEY); } catch (error) { /* Storage can be unavailable. */ }
    };

    const initQuoteForm = (section) => {
      if (!section || section.dataset.quoteInitialized === 'true') return;
      const PickerClass = window.UncommonProductPicker;
      if (!PickerClass || typeof PickerClass !== 'function') {
        console.warn('[quote-form] window.UncommonProductPicker unavailable; picker disabled.');
        return;
      }
      section.dataset.quoteInitialized = 'true';

      const form = section.querySelector('.quote-form');
      const emptyEl = section.querySelector('[data-quote-empty]');
      const rowsContainer = section.querySelector('[data-quote-rows]');
      const summaryContainer = section.querySelector('[data-quote-summary-items]');
      const errorEl = section.querySelector('[data-quote-products-error]');
      const pickerTriggers = section.querySelectorAll('[data-open-picker]');
      const addAnother = Array.from(pickerTriggers).filter((button) => !button.closest('[data-quote-empty]'));
      const countEl = section.querySelector('[data-product-count]');
      const notes = section.querySelector('[data-notes]');
      const noteCount = section.querySelector('[data-note-count]');
      const banner = section.querySelector('[data-draft-banner]');
      const status = section.querySelector('[data-draft-status]');
      const rowTemplate = section.querySelector('[data-quote-row-template]');
      const summaryTemplate = section.querySelector('[data-summary-item-template]');
      const submissionFields = section.querySelector('[data-quote-submission-fields]');
      const pickerNode = section.querySelector('[data-product-picker]');
      const pickerMessagesNode = pickerNode?.querySelector('[data-product-picker-messages]');
      const params = new URLSearchParams(window.location.search);
      const limit = Number(section.dataset.quoteLimit || 10);
      const seedProductId = section.dataset.quoteSeedProductId || '';
      const contextValues = {
        product_handle: params.get('product_handle'),
        product_title: params.get('product_title'),
        collection_handle: params.get('collection_handle')
      };
      const contextEl = section.querySelector('[data-quote-context]');
      const contextTitleEl = contextEl?.querySelector('[data-quote-context-title]');
      const contextMetaEl = contextEl?.querySelector('[data-quote-context-meta]');

      const selected = new Map();
      const productCache = new Map();
      const rowsByProductId = new Map();
      const summaryByProductId = new Map();

      let pickerMessages = {};
      try { pickerMessages = pickerMessagesNode ? JSON.parse(pickerMessagesNode.textContent) : {}; } catch (_) { pickerMessages = {}; }

      const setContext = () => {
        Object.entries(contextValues).forEach(([key, value]) => {
          const field = section.querySelector(`[data-quote-context-field="${key}"]`);
          if (!field || !value) return;
          field.value = String(value).slice(0, 255);
          field.disabled = false;
        });
        if (contextEl && (contextValues.product_title || contextValues.product_handle)) {
          if (contextTitleEl) contextTitleEl.textContent = contextValues.product_title || contextValues.product_handle;
          if (contextMetaEl && contextValues.collection_handle) contextMetaEl.textContent = ` · ${contextValues.collection_handle}`;
          contextEl.hidden = false;
        }
      };

      const updateCount = () => {
        const total = selected.size;
        if (countEl) countEl.textContent = total + (total === 1 ? ' item' : ' items');
        const showEmpty = total === 0;
        if (emptyEl) emptyEl.hidden = !showEmpty;
        if (addAnother && addAnother.length) {
          addAnother.forEach((button) => {
            button.hidden = showEmpty;
          });
        }
        rowsContainer?.querySelectorAll('[data-remove-product]').forEach((button) => { button.disabled = false; });
        if (errorEl) {
          if (showEmpty) {
            errorEl.hidden = true;
          }
        }
      };

      const syncRowToState = (productId) => {
        const row = rowsByProductId.get(productId);
        const summary = summaryByProductId.get(productId);
        if (!row || !summary) return;
        const state = selected.get(productId);
        if (!state) return;
        const quantityInput = row.querySelector('[data-quantity-input]');
        const variantSelect = row.querySelector('[data-variant-select]');
        const skuEl = row.querySelector('[data-row-sku]');
        const skuValueEl = row.querySelector('[data-row-sku-value]');
        const summaryPack = summary.querySelector('[data-summary-pack]');
        const summaryQty = summary.querySelector('[data-summary-quantity]');
        const summarySku = summary.querySelector('[data-summary-sku]');
        const summarySkuValue = summary.querySelector('[data-summary-sku-value]');

        if (variantSelect && state.variants && state.variants.length > 0) {
          const desiredVariantId = state.variantId;
          if (desiredVariantId && state.variants.some((v) => String(v.id) === String(desiredVariantId))) {
            variantSelect.value = String(desiredVariantId);
          } else {
            const firstAvailable = state.variants.find((v) => v.available) || state.variants[0];
            if (firstAvailable) variantSelect.value = String(firstAvailable.id);
          }
        }
        const selectedOption = variantSelect?.selectedOptions?.[0];
        const selectedVariant = state.variants?.find((v) => String(v.id) === variantSelect?.value) || null;
        if (selectedOption && summaryPack) summaryPack.textContent = selectedOption.textContent || '';
        if (selectedVariant && skuEl && skuValueEl) {
          if (selectedVariant.sku) {
            skuValueEl.textContent = selectedVariant.sku;
            skuEl.hidden = false;
          } else {
            skuEl.hidden = true;
          }
        } else if (skuEl) {
          skuEl.hidden = true;
        }
        if (summarySku && summarySkuValue && selectedVariant && selectedVariant.sku) {
          summarySkuValue.textContent = selectedVariant.sku;
          summarySku.hidden = false;
        } else if (summarySku) {
          summarySku.hidden = true;
        }
        if (quantityInput && summaryQty) summaryQty.textContent = String(state.quantity);
      };

      const updateVariantFieldState = (productId, variantId) => {
        const state = selected.get(productId);
        if (!state) return;
        state.variantId = variantId;
        const variant = state.variants?.find((v) => String(v.id) === String(variantId));
        state.variantLabel = variant ? (variant.option2 || variant.title || '') : '';
        state.sku = variant ? (variant.sku || '') : '';
        syncRowToState(productId);
      };

      const updateQuantityFieldState = (productId, quantity) => {
        const state = selected.get(productId);
        if (!state) return;
        state.quantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
        syncRowToState(productId);
      };

      const fetchProduct = (handle) => {
        if (!handle) return Promise.resolve(null);
        if (productCache.has(handle)) return productCache.get(handle);
        const promise = fetch(rootRoute() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('product fetch failed');
            return response.json();
          })
          .catch((error) => {
            productCache.delete(handle);
            throw error;
          });
        productCache.set(handle, promise);
        return promise;
      };

      const populateRowVariants = (productId, product) => {
        const state = selected.get(productId);
        if (!state || !product) return;
        const variants = Array.isArray(product.variants) ? product.variants : [];
        state.product = product;
        state.handle = product.handle || state.handle;
        state.title = product.title || state.title;
        state.image = (product.featured_image && (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.url || product.featured_image.src)) || state.image || '';
        state.url = product.url || (product.handle ? absoluteUrl('/products/' + product.handle) : '') || state.url;
        state.variants = variants;
        if (!state.variantId) {
          const firstAvailable = variants.find((v) => v.available) || variants[0];
          state.variantId = firstAvailable ? String(firstAvailable.id) : '';
        }
        const row = rowsByProductId.get(productId);
        if (row) {
          const variantSelect = row.querySelector('[data-variant-select]');
          const imageEl = row.querySelector('[data-row-image]');
          const titleEl = row.querySelector('[data-row-title]');
          const metaEl = row.querySelector('[data-row-meta]');
          if (variantSelect) {
            variantSelect.innerHTML = variants.map((variant) => {
              const unavailable = !variant.available;
              const label = variant.option2 || variant.title || variant.sku || ('Variant ' + variant.id);
              const full = unavailable ? label + ' (' + t('quote.variant_unavailable', 'Unavailable') + ')' : label;
              return `<option value="${escapeHtml(variant.id)}">${escapeHtml(full)}</option>`;
            }).join('');
            variantSelect.disabled = variants.length === 0;
          }
          if (imageEl && state.image) {
            imageEl.src = state.image;
            imageEl.alt = state.title || '';
          }
          if (titleEl) titleEl.textContent = state.title || '';
          if (metaEl && product.vendor) metaEl.textContent = product.vendor;

          const summary = summaryByProductId.get(productId);
          if (summary) {
            const summaryImage = summary.querySelector('[data-summary-image]');
            const summaryTitle = summary.querySelector('[data-summary-title]');
            if (summaryImage && state.image) {
              summaryImage.src = state.image;
              summaryImage.alt = state.title || '';
            }
            if (summaryTitle) summaryTitle.textContent = state.title || '';
          }

          if (variants.length === 0 && errorEl) {
            errorEl.textContent = t('quote.variant_load_error', "We couldn't load this product's pack sizes. Try removing it and adding it again.");
            errorEl.hidden = false;
          }
        }
        syncRowToState(productId);
      };

      const addRow = (product) => {
        if (!product || !product.id) return false;
        const productId = String(product.id);
        if (selected.has(productId)) return false;
        const handle = product.handle;
        if (!rowTemplate || !summaryTemplate) return false;
        const rowClone = rowTemplate.content.firstElementChild.cloneNode(true);
        const summaryClone = summaryTemplate.content.firstElementChild.cloneNode(true);
        rowsContainer.appendChild(rowClone);
        summaryContainer.appendChild(summaryClone);

        const initialState = {
          product: null,
          id: productId,
          handle: handle,
          title: product.title || '',
          image: product.image || '',
          url: absoluteUrl(product.url || (handle ? '/products/' + handle : '')),
          variants: [],
          variantId: '',
          variantLabel: '',
          sku: '',
          quantity: 1
        };
        selected.set(productId, initialState);
        rowsByProductId.set(productId, rowClone);
        summaryByProductId.set(productId, summaryClone);

        const imageEl = rowClone.querySelector('[data-row-image]');
        const titleEl = rowClone.querySelector('[data-row-title]');
        if (imageEl && product.image) imageEl.src = product.image;
        if (imageEl) imageEl.alt = product.title || '';
        if (titleEl) titleEl.textContent = product.title || '';
        const summaryImage = summaryClone.querySelector('[data-summary-image]');
        const summaryTitle = summaryClone.querySelector('[data-summary-title]');
        if (summaryImage && product.image) summaryImage.src = product.image;
        if (summaryImage) summaryImage.alt = product.title || '';
        if (summaryTitle) summaryTitle.textContent = product.title || '';

        const variantSelect = rowClone.querySelector('[data-variant-select]');
        variantSelect?.addEventListener('change', (event) => {
          updateVariantFieldState(productId, event.target.value);
        });
        const quantityInput = rowClone.querySelector('[data-quantity-input]');
        quantityInput?.addEventListener('input', (event) => {
          const next = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
          if (Number.parseInt(event.target.value, 10) <= 0) event.target.value = String(next);
          updateQuantityFieldState(productId, next);
        });
        quantityInput?.addEventListener('blur', (event) => {
          const next = Math.max(1, Number.parseInt(event.target.value, 10) || 1);
          event.target.value = String(next);
          updateQuantityFieldState(productId, next);
        });
        const removeButton = rowClone.querySelector('[data-remove-product]');
        removeButton?.addEventListener('click', () => {
          removeRow(productId);
        });

        updateCount();
        syncRowToState(productId);

        if (handle) {
          fetchProduct(handle)
            .then((fullProduct) => populateRowVariants(productId, fullProduct))
            .catch(() => {
              selected.delete(productId);
              rowClone.remove();
              summaryClone.remove();
              rowsByProductId.delete(productId);
              summaryByProductId.delete(productId);
              if (errorEl) {
                errorEl.textContent = t('quote.variant_load_error', "We couldn't load this product's pack sizes. Try removing it and adding it again.");
                errorEl.hidden = false;
              }
              updateCount();
            });
        }
        return true;
      };

      const addRowsFromPicker = (products) => {
        let added = 0;
        (Array.isArray(products) ? products : []).forEach((product) => {
          if (addRow(product)) added += 1;
        });
        return added;
      };

      const removeRow = (productId) => {
        const row = rowsByProductId.get(productId);
        const summary = summaryByProductId.get(productId);
        if (row) row.remove();
        if (summary) summary.remove();
        rowsByProductId.delete(productId);
        summaryByProductId.delete(productId);
        selected.delete(productId);
        updateCount();
      };

      const buildSubmissionFields = () => {
        if (!submissionFields) return;
        submissionFields.innerHTML = '';
        const fragment = document.createDocumentFragment();
        let order = 1;
        selected.forEach((state) => {
          const variant = state.variants?.find((v) => String(v.id) === String(state.variantId)) || null;
          const variantLabel = variant ? (variant.option2 || variant.title || '') : '';
          const sku = variant ? (variant.sku || '') : '';
          const values = [
            ['title', state.title],
            ['handle', state.handle],
            ['variant id', state.variantId],
            ['SKU', sku],
            ['pack size', variantLabel],
            ['quantity', String(state.quantity)]
          ];
          values.forEach(([key, value]) => {
            if (!value) return;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `contact[Product ${order} ${key}]`;
            input.value = String(value).slice(0, 255);
            fragment.appendChild(input);
          });
          order += 1;
        });
        submissionFields.appendChild(fragment);
      };

      const validateProducts = () => {
        if (errorEl) errorEl.hidden = true;
        if (selected.size === 0) {
          if (errorEl) {
            errorEl.textContent = t('quote.products_required', 'Add at least one product before sending your quote request.');
            errorEl.hidden = false;
          }
          const productsCard = section.querySelector('.quote-form__products');
          if (productsCard) productsCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return false;
        }
        return true;
      };

      const validateContact = () => {
        const invalid = [];
        form.querySelectorAll('input[required]').forEach((field) => {
          if (!field.checkValidity() || !field.value.trim()) invalid.push(field);
        });
        return invalid.length === 0;
      };

      const handleOpenPicker = (event) => {
        const trigger = event.currentTarget || event.target.closest('[data-open-picker]');
        if (trigger) picker.setLastTrigger(trigger);
        picker.open();
      };

      pickerTriggers.forEach((button) => button.addEventListener('click', handleOpenPicker));

      let picker = null;
      if (pickerNode) {
        picker = new PickerClass(pickerNode, {
          limit,
          messages: pickerMessages,
          recommendationsProductId: seedProductId || null,
          getExcludedIds: () => [...selected.keys()],
          onConfirm: (products) => {
            addRowsFromPicker(products);
            if (errorEl) errorEl.hidden = true;
          }
        });
        pickerNode.removeAttribute('hidden');
        pickerNode.addEventListener('product-picker:confirm', (event) => {
          const products = event.detail && event.detail.products;
          if (Array.isArray(products) && products.length) {
            addRowsFromPicker(products);
            if (errorEl) errorEl.hidden = true;
          }
        });
      }

      const saveDraftPayload = () => {
        const products = [];
        selected.forEach((state) => {
          const variant = state.variants?.find((v) => String(v.id) === String(state.variantId)) || null;
          products.push({
            id: state.id,
            title: state.title,
            handle: state.handle,
            url: state.url,
            image: state.image,
            variantId: state.variantId,
            quantity: state.quantity
          });
        });
        return {
          version: VERSION,
          expiresAt: Date.now() + TTL,
          products,
          eventDate: section.querySelector('[data-draft-field="event_date"]')?.value || '',
          notes: String(notes?.value || '').slice(0, 1000)
        };
      };

      const restoreDraft = (draft) => {
        const restoreErrors = [];
        const restoreSequential = async () => {
          for (const item of (Array.isArray(draft.products) ? draft.products : [])) {
            if (!item || !item.handle) continue;
            const productStub = { id: item.id, title: item.title, handle: item.handle, url: item.url, image: item.image };
            const added = addRow(productStub);
            if (!added) continue;
            try {
              const fullProduct = await fetchProduct(item.handle);
              const state = selected.get(String(item.id));
              if (state && fullProduct) {
                populateRowVariants(String(item.id), fullProduct);
                if (item.variantId) updateVariantFieldState(String(item.id), item.variantId);
                updateQuantityFieldState(String(item.id), item.quantity || 1);
              }
            } catch (_) {
              removeRow(String(item.id));
              restoreErrors.push(item.handle);
            }
          }
        };
        restoreSequential().then(() => {
          const eventDate = section.querySelector('[data-draft-field="event_date"]');
          if (eventDate) eventDate.value = draft.eventDate || '';
          if (notes) notes.value = String(draft.notes || '').slice(0, 1000);
          syncNotes();
          if (banner) banner.hidden = true;
          if (status) {
            if (restoreErrors.length) {
              status.textContent = 'Draft restored. Some products are no longer available: ' + restoreErrors.join(', ');
            } else {
              status.textContent = 'Draft restored.';
            }
          }
          updateCount();
        });
      };

      section.querySelector('[data-save-draft]')?.addEventListener('click', () => {
        const payload = saveDraftPayload();
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
          if (status) status.textContent = 'Draft saved for 30 days.';
          if (banner) banner.hidden = true;
        } catch (error) {
          if (status) status.textContent = 'Draft could not be saved in this browser.';
        }
      });
      section.querySelector('[data-restore-draft]')?.addEventListener('click', () => {
        const draft = parseDraft();
        if (draft) restoreDraft(draft);
      });
      section.querySelector('[data-clear-draft]')?.addEventListener('click', () => {
        clearDraft();
        if (banner) banner.hidden = true;
        if (status) status.textContent = 'Draft cleared.';
      });

      const syncNotes = () => { if (notes && noteCount) noteCount.textContent = `${notes.value.length}/1000`; };
      notes?.addEventListener('input', syncNotes);

      form?.addEventListener('submit', (event) => {
        if (errorEl) errorEl.hidden = true;
        if (!validateProducts()) {
          event.preventDefault();
          return;
        }
        buildSubmissionFields();
      });

      setContext();

      const contextHandle = contextValues.product_handle;
      if (contextHandle && !parseDraft()) {
        fetchProduct(contextHandle)
          .then((product) => {
            if (!product) return;
            addRow({
              id: product.id,
              title: product.title,
              handle: product.handle,
              url: product.url,
              image: product.featured_image && (typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.url || product.featured_image.src)
            });
          })
          .catch(() => { /* ignore context auto-add failure */ });
      }

      updateCount();
      if (form?.querySelector('[data-form-success]')) {
        clearDraft();
      } else {
        const availableDraft = parseDraft();
        if (availableDraft && banner) banner.hidden = false;
      }
      syncNotes();
    };

    const initAll = (root = document) => root.querySelectorAll('[data-quote-section]').forEach(initQuoteForm);
    const initOrRetry = () => {
      if (window.UncommonProductPicker && typeof window.UncommonProductPicker === 'function') {
        initAll();
      } else if (document.querySelectorAll('[data-quote-section]').length > 0) {
        // Picker asset (defer) hasn't loaded yet; retry on next tick up to a sane cap.
        let attempts = 0;
        const retry = () => {
          if (window.UncommonProductPicker) {
            initAll();
            return;
          }
          if (++attempts < 50) {
            window.setTimeout(retry, 50);
          } else {
            console.warn('[quote-form] Gave up waiting for window.UncommonProductPicker after 2.5s.');
          }
        };
        window.setTimeout(retry, 50);
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initOrRetry());
    } else {
      initOrRetry();
    }
    document.addEventListener('shopify:section:load', (event) => {
      if (window.UncommonProductPicker) initAll(event.target);
      else window.setTimeout(() => initAll(event.target), 100);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
